export enum TileFeedBackEnum {
  NegativeTaskFeedback = 'Negative Task Feedback',
  PositiveTaskFeedback = 'Positive Task Feedback',
}
